import { UseFormRegisterReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CheckboxContainer } from "./style";
import Checkbox from "../shared/Checkbox";

export interface IInputProps {
  register: UseFormRegisterReturn<string>;
  errors: any;
  warning?: string;
  customError?: string;
}

interface IReduceOnlyInputProps {
  reduceOnly: boolean;
  onToggle: () => void;
}
export function ReduceOnlyInput({
  reduceOnly,
  onToggle,
}: IReduceOnlyInputProps) {
  const { t } = useTranslation("app", {
    keyPrefix: "TradeForm.PerpsTradeForm.Form",
  });
  return (
    <CheckboxContainer>
      <Checkbox
        checked={reduceOnly}
        onToggle={onToggle}
        title={t("reduce_only")}
      />
    </CheckboxContainer>
  );
}
